import { formatProgDetails, formatMoreProgDetails } from "../helpers";
import {
  FETCH_PROG,
  FETCH_PROG_IS_LOADING,
  FETCH_PROG_HAS_ERRORED,
  FETCH_PROG_AVAIL,
  FETCH_PROG_AVAIL_IS_LOADING,
  FETCH_PROG_AVAIL_HAS_ERRORED,
  COMBINED_PROG_LOAD_SUCCESS,
} from "./types";
import { globalFetch } from "./globalActions";
import { fetchProgrammeMyS4C } from "./MyS4CActions";
import { PLAYER_OD } from "../constants";
import { fetchProgResume, fetchAdverts } from "../actions";

///////////
// Programme Page //
///////////

export function resetProg(lang) {
  return {
    type: FETCH_PROG,
    payload: {},
  };
}

export function resetProgPlus() {
  return {
    type: COMBINED_PROG_LOAD_SUCCESS,
    payload: false,
  };
}

/*
 *	Chained fetch request to get the prog/series object plus
 */
export function fetchProgPlus(id, isSeriesProg, num_results) {
  let progFetch = !isSeriesProg ? fetchProg : fetchSeriesProg;
  return (dispatch, getState) => {
    dispatch({ type: COMBINED_PROG_LOAD_SUCCESS, payload: false });
    return dispatch(progFetch(id)).then(() => {
      // Grab the prog / series blob first
      let progDetails =
        getState().prog &&
        getState().prog.success &&
        getState().prog.success.full_prog_details
          ? getState().prog.success.full_prog_details
          : null;
      if (progDetails && progDetails.id) {
        const progId = progDetails.id;
        return dispatch(fetchProgExtras(progId)).then(() => {
          // if that's successful then go for the ads and progresume
          let state = getState();
          let resumeData = state.progResumeFetch;
          let resumeDataLoaded =
            resumeData && resumeData.pid && resumeData.pid === progId;
          let stingsLoaded =
            state.stingSeriesIdItems && state.stingSeriesIdItems.length > 0;
          if (resumeDataLoaded && stingsLoaded) {
            return dispatch(fetchProgrammeMyS4C(progId, progDetails.series_id, num_results, progDetails.genre_ids)).then(() => {
              // If thats successful then grab the mys4c bits
              if (getState().list.success) {
                // Dispatch all complete success
                dispatch({ type: COMBINED_PROG_LOAD_SUCCESS, payload: true });
              }
            });
          }
        });
      }
    });
  };
}

/*
 *	Refetch just the progresume but re check success on complete
 */
export function fetchProgResumePlus(id, series_id, num_results, genre_ids) {
  return (dispatch, getState) => {
    dispatch({ type: COMBINED_PROG_LOAD_SUCCESS, payload: false });
    return dispatch(fetchProgResume(PLAYER_OD, id)).then(() => {
      // Grab the prog / series blob first
      let state = getState();
      let resumeData = state.progResumeFetch;
      let resumeDataLoaded =
        resumeData && resumeData.pid && resumeData.pid === id;
      if (resumeDataLoaded) {
        return dispatch(fetchProgrammeMyS4C(id, series_id, num_results, genre_ids)).then(() => {
          // If thats successful then grab the mys4c bits
          if (getState().list.success) {
            // Dispatch all complete success
            dispatch({ type: COMBINED_PROG_LOAD_SUCCESS, payload: true });
          }
        });
      }
    });
  };
}

/**
 * Load the extras in parallel to be quicker
 * 	- progResume
	- Adverts
	- Feature data (removed this)
 */
export function fetchProgExtras(id) {
  return (dispatch) =>
    Promise.all([
      dispatch(fetchProgResume(PLAYER_OD, id)),
      dispatch(fetchAdverts()),
    ]);
}

export function fetchProg(id) {
  return globalFetch({
    urlPath: `full_prog_details`,
    extraParams: `&programme_id=${id}&show_prog_in_series=Y`,
    reducerIsLoading: FETCH_PROG_IS_LOADING,
    reducerError: FETCH_PROG_HAS_ERRORED,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch(fetchProgDataSuccess(itemObj));
    },
  });
}

export function fetchSeriesProg(id) {
  return globalFetch({
    urlPath: `series_details`,
    extraParams: `&series_id=${id}&show_prog_in_series=Y`,
    reducerIsLoading: FETCH_PROG_IS_LOADING,
    reducerError: FETCH_PROG_HAS_ERRORED,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch(fetchProgDataSuccess(itemObj));
    },
  });
}

export function fetchProgDataSuccess(items) {
  //The Programme Full Details
  let progItems = {};
  if (items.full_prog_details && items.full_prog_details.length > 0) {
    for (var key in items.full_prog_details[0]) {
      if (key === "thumbnail_url") {
        progItems[key] = items.full_prog_details[0][key].replace(/\s/g, "%20");
      } else {
        progItems[key] = items.full_prog_details[0][key];
      }
    }
  }

  //The Series Details
  let seriesItems = [];
  if (
    items.other_progs_in_series &&
    Object.keys(items.other_progs_in_series).length > 0
  ) {
    Object.entries(items.other_progs_in_series).forEach(([key, value]) => {
      seriesItems[key] = formatMoreProgDetails(value);
    });
  }

  //The More Like Details
  let moreLikeItems = [];
  if (
    items.other_progs_in_genres &&
    Object.keys(items.other_progs_in_genres).length > 0
  ) {
    Object.entries(items.other_progs_in_genres).forEach(([key, value]) => {
      moreLikeItems[key] = formatProgDetails(value);
    });
  }

  //Combine Everything into object
  const allProgs = {
    full_prog_details: progItems,
    other_progs_in_series: seriesItems.reverse(),
    other_progs_in_genres: moreLikeItems,
  };

  return { type: FETCH_PROG, payload: allProgs };
}

export function fetchProgAvail(id) {
  return globalFetch({
    urlPath: `check_avail`,
    extraParams: `&ids=${id}`,
    reducerIsLoading: FETCH_PROG_AVAIL_IS_LOADING,
    reducerError: FETCH_PROG_AVAIL_HAS_ERRORED,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch(fetchProgAvailSuccess(itemObj, id));
    },
  });
}

export function fetchProgAvailSuccess(items, id) {
  return {
    type: FETCH_PROG_AVAIL,
    payload: items && items.progs && items.progs.length > 0 ? 0 : id,
  };
}

export function resetProgAvail() {
  return { type: FETCH_PROG_AVAIL, payload: "reset" };
}
